import queryString from 'query-string';
export const extractRequestParams = (search?: string) => {
    const searchString = search ?? window.location.search;
    const params = queryString.parse(searchString);
    const code = decodeURIComponent((params.code as string) || '');
    const username = decodeURIComponent((params.username as string) || '');
    const newEmail = decodeURIComponent((params.newEmail as string) || '');
    return { code, username, newEmail };
};
